import { Struct } from 'shoteyes-types';
import { Workbook, Worksheet } from 'exceljs';
import { ExcelSheetItem } from './types';

export class Excel {

  async generate(sheetItems: ExcelSheetItem[], formName: Struct.Form['name']): Promise<Blob> {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(formName);
    worksheet.columns = sheetItems;
    worksheet.getRow(1).alignment = { wrapText: true };
    worksheet.getRow(1).eachCell(cell => {
      cell.fill = {
        type: 'pattern',
        pattern: 'darkVertical',
        fgColor: { argb: 'FFEEEEEE' },
        bgColor: { argb: 'FFEEEEEE' }
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
    return new Blob([await workbook.xlsx.writeBuffer()], { type: 'text/plain' });
  }

  async errorExcel(buffer: ArrayBuffer): Promise<Blob> {
    return new Blob([new Uint8Array(buffer)], { type: 'text/plain' });
  }

  /**
   * 将文件选择组件选中的 excel 文件，通过 exceljs 读取为 Worksheet 数据数组
   * 可以通过遍历 worksheets 获取数据
   */
  async read(file: Blob | File): Promise<Worksheet[]> {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    return await new Promise((resolve, reject) => {
      reader.onload = async (event): Promise<void> => {
        if (event.target?.result == null) {
          return;
        }

        const workbook = new Workbook();
        try {
          await workbook.xlsx.load(event.target.result as ArrayBuffer);
        } catch (error) {
          return reject(error);
        }
        resolve(workbook.worksheets);
      };
      reader.onerror = (): void => reject();
    });
  }

}
